module.exports = __webpack_public_path__ + "static/media/Postales-09.1f484677.png";